<template>
  <div class="fill-height"
    :style="[
      {'background-color': `#F4F4F4`} 
    ]"
  >
    <strategio-app-bar></strategio-app-bar>
    <v-main style="height:100vh;padding-top:87px">
      <div style="max-height:100%; overflow:auto">
        <v-container>
          <v-row class="strategio-titles-windows" >
            <v-col cols="5" align-self="center">
              <v-icon  :color="'black'"  style="font-size:52px;padding-bottom: 30px; padding-right: 10px;"
              >ico-icon-config</v-icon>
              <span style="font-size:45px;font-weight:bold;color:black;-webkit-text-stroke: 2px black;">
                Autoservicios
              </span>
            </v-col>
          </v-row>

          <v-row class="ma-5 px-5">
            <autoservicio-list-groups></autoservicio-list-groups>
          </v-row>
        </v-container>
      </div>
    </v-main>
  </div>
</template>

<script>
import StrategioAppBar from '../../components/header-bar/strategio-app-bar.vue'
import AutoservicioListGroups from '../../components/autoservicios/groups/autoservicio-list-groups.vue'

export default {
  name: 'autoservicios',
  components: {
    StrategioAppBar,
    AutoservicioListGroups
  },
  data () {
    return {
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/routes/autoservicios/autoservicios.vue